import { useRef, useEffect } from "react";
import "./index.css";

// Components Imports
import PrimaryButton from "../../_utils/CommonButtons/PrimaryButton";
import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";
import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import PrimaryWithIconButton from "../../_utils/CommonButtons/PrimaryWithIconButton";
import SecondaryRightIconSmallButton from "../../_utils/CommonButtons/SecondaryRightIconSmallButton";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const MISReportCreateSorting = ({
  dropdownStates,
  setDropdownStates,
  selectedValues,
  columnsData,
  isFirstConfirmed,
  sortOptions,
  selectedColumns,
  handleOptionSelect,
  handleSelectColumn,
  handleSelectAllColumn,
  handleClearColumns,
  handleClearSort,
  selectedOption,
}) => {
  const dropdown1Ref = useRef(null);
  const dropdown2Ref = useRef(null);

  const hasAdditionalColumnsSelected = () => {
    if (selectedOption === "User") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > GlobalConfiguration?.lengthCheckOne ||
        (selectedColumns.length === GlobalConfiguration?.lengthCheckOne &&
          selectedColumns[0].columnName !== "Username")
      );
    } else if (selectedOption === "Bank statement") {
      const selectedColumns = columnsData.filter(
        (data) => data?.selected === true,
      );
      return (
        selectedColumns.length > GlobalConfiguration?.lengthCheckOne ||
        (selectedColumns.length === GlobalConfiguration?.lengthCheckOne &&
          selectedColumns[0].columnName !== "Account ID")
      );
    } else {
      return columnsData.some((data) => data?.selected === true);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdown1Ref.current &&
        !dropdown1Ref.current.contains(event.target)
      ) {
        setDropdownStates((prev) =>
          prev.dropdown1 ? { ...prev, dropdown1: false } : prev,
        );
      }
      if (
        dropdown2Ref.current &&
        !dropdown2Ref.current.contains(event.target)
      ) {
        setDropdownStates((prev) =>
          prev.dropdown2 ? { ...prev, dropdown2: false } : prev,
        );
      }
    };

    if (dropdownStates.dropdown1 || dropdownStates.dropdown2) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownStates.dropdown1, dropdownStates.dropdown2, setDropdownStates]);

  return (
    <div
      className={`flex flex-col relative gap-gap-md mx-margin-sm Qsmd:mx-margin-xs h-fit mb-margin-md`}
    >
      <div className="flex flex-col rounded-border-radius-md bg-primary-card Qmd:h-fit p-padding-md gap-gap-md">
        <div className="flex justify-between gap-gap-md Qsmd:gap-gap-base">
          <TitleSubtitlePair
            title="Columns"
            subtitle="Selected columns will appear on the MIS report."
            variant="md"
            titleColor="text-primary"
            isBold={true}
          />
          <div className="flex-shrink-0">
            <SecondaryRightIconSmallButton
              btnText="Select all"
              btnType="button"
              handleFunction={() => handleSelectAllColumn()}
              enabledTextColor="var(--text-primary)"
              enabledBgColor={
                columnsData.every((data) => data?.selected === true)
                  ? "var(--positive-bg)"
                  : "var(--primary-nav)"
              }
              hoverOption={
                columnsData.every((data) => data?.selected === true)
                  ? "black"
                  : "white"
              }
              icon={
                columnsData.every((data) => data?.selected === true)
                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
              }
            />
          </div>
        </div>
        <div className="select-column-container">
          {columnsData?.map((fileds, index) => {
            return (
              <>
                <PrimaryWithIconButton
                  btnText={fileds?.columnName}
                  btnType="button"
                  handleFunction={() => {
                    handleSelectColumn(fileds?.columnId);
                  }}
                  enabledBgColor={
                    fileds?.selected
                      ? "var(--positive-bg)"
                      : "var(--primary-nav-act)"
                  }
                  enabledTextColor="var(--text-primary)"
                  isLoading={false}
                  icon={
                    fileds?.selected ||
                    (selectedOption === "User" &&
                      fileds?.columnName === "Username") ||
                    (selectedOption === "Bank statement" &&
                      fileds?.columnName === "Account ID")
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                  }
                  isDisabled={
                    (selectedOption === "User" &&
                      fileds?.columnName === "Username") ||
                    (selectedOption === "Bank statement" &&
                      fileds?.columnName === "Account ID")
                  }
                  hoverOption={fileds?.selected ? "black" : "white"}
                  iconToBeAlign={"right"}
                />
              </>
            );
          })}
        </div>
        <div className="confirm-container">
          <PrimaryButton
            enabledBgColor=""
            btnText="Clear"
            outLineColor="var(--text-primary)"
            enabledTextColor="var(--text-primary)"
            handleFunction={() => handleClearColumns()}
            hoverOption="white"
            isDisabled={!hasAdditionalColumnsSelected()}
          />
        </div>
      </div>
      <div
        className="Qmd:h-fit flex flex-col gap-gap-md relative rounded-border-radius-md bg-primary-card p-padding-md overflow-visible"
        style={{
          opacity:
            selectedOption === "User" ||
            selectedOption === "Bank statement" ||
            (isFirstConfirmed &&
              columnsData.some((data) => data?.selected === true))
              ? "var(--base-opacity)"
              : "var(--light-opacity)",
          pointerEvents:
            selectedOption === "User" ||
            selectedOption === "Bank statement" ||
            (isFirstConfirmed &&
              columnsData.some((data) => data?.selected === true))
              ? "auto"
              : "none",
        }}
      >
        <div className="flex flex-col gap-y-gap-xs">
          <p className="font-semibold text-font-md text-text-primary">
            Sort By{" "}
            <span className="font-normal text-font-md  text-text-primary">
              (Optional)
            </span>
          </p>
          <p className="font-normal text-text-secondary text-font-xs">
            MIS report will be sorted by the order that has been selected below.
          </p>
        </div>

        {true ? ( // Always show dropdowns (edit mode)
          <div className="flex flex-col Qmd:flex-row gap-gap-md">
            <div
              style={{ minWidth: "var(--dropdown-width)" }}
              className="w-full flex flex-col Qsmd:w-dropdown-width gap-y-gap-xs"
              ref={dropdown1Ref}
            >
              <p className="text-font-xs text-text-secondary">Column</p>
              <SingleSelectDropDownComponent
                options={selectedColumns.map((col) => col.columnName)}
                selected={selectedValues.dropdown1}
                setSelected={(value) => handleOptionSelect("dropdown1", value)}
                type="small"
                showSearch={true}
                placeholder="Select column"
                searchPlaceholder="Search column"
                disabled={false}
              />
            </div>
            <div
              style={{ minWidth: "var(--dropdown-width)" }}
              className="w-full flex flex-col Qsmd:w-dropdown-width gap-y-gap-xs"
              ref={dropdown2Ref}
            >
              <p className="text-font-xs text-text-secondary">Sorting</p>
              <SingleSelectDropDownComponent
                options={sortOptions}
                selected={selectedValues.dropdown2}
                setSelected={(value) => handleOptionSelect("dropdown2", value)}
                type="small"
                showSearch={false}
                placeholder="Select sorting"
                searchPlaceholder=""
                disabled={false}
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-gap-md">
            {selectedValues.dropdown1 !== "" && (
              <div className="select-column-cards bg-primary-nav-act cursor-pointer global-hover-white  flex justify-center items-center pl-padding-sm: pr-padding-sm">
                <p className="text-text-primary text-font-xs font-normal">
                  {selectedValues.dropdown1}
                </p>
              </div>
            )}
            {selectedValues.dropdown2 !== "" && (
              <div className="select-column-cards bg-primary-nav-act cursor-pointer global-hover-white  flex justify-center items-center pl-padding-sm: pr-padding-sm">
                <p className="text-text-primary text-font-xs font-normal">
                  {selectedValues.dropdown2}
                </p>
              </div>
            )}
          </div>
        )}

        <div className="flex justify-end  gap-gap-md">
          <PrimaryButton
            enabledBgColor=""
            btnText="Clear"
            outLineColor="var(--text-primary)"
            enabledTextColor="var(--text-primary)"
            handleFunction={handleClearSort}
            hoverOption="white"
            isDisabled={
              !(
                selectedValues.dropdown1 !== "" ||
                selectedValues.dropdown2 !== ""
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default MISReportCreateSorting;
